// extracted by mini-css-extract-plugin
export default {"container":"styles_container__QqOtd","hideContainer":"styles_hideContainer__e9wXB","mainContainer":"styles_mainContainer__nSfnv","content":"styles_content__-BHdd"};